// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__gMmnK","productName":"Table_productName__2Uu1Q"};